"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var TopicClosed = function TopicClosed(_ref) {
  var message = _ref.message;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('box', 'box--info', 'box--rounded')
  }, (0, _preact.h)("div", {
    className: "box__pad qa-mesg-topic-closed"
  }, message));
};

var _default = TopicClosed;
exports.default = _default;